module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_erythristic.43df7d04.png";